import { isEmpty } from 'lodash';
export default function formatAddress(address) {
  if (isEmpty(address)) {
    return undefined;
  }
  var finalAdr = '';
  finalAdr += address.line_1 ? "".concat(address.line_1, ", ") : '';
  finalAdr += address.city ? "".concat(address.city, ", ") : '';
  finalAdr += address.state ? "".concat(address.state, " ") : '';
  finalAdr += address.postal_code ? "".concat(address.postal_code) : '';
  return finalAdr;
}
//# sourceMappingURL=formatAddress.js.map